export class BulkSelectSnapshotsForResourcesResponseItemsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "BulkSelectSnapshotStatus",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkSelectSnapshotsForResourcesResponseItemsInner.attributeTypeMap;
    }
    constructor() {
    }
}
